import { GET_BIN_REQUEST, UPDATE_BIN_REQUEST, RESET_BIN_DATA, TRIGGER_RESET_BIN_DATA } from "./updateBin.constants";



export const updateBinValues = (payload) => {
  return {
    type: UPDATE_BIN_REQUEST,
    payload
  };
};

export const getBinData = (payload)=>{
  return {
    type: GET_BIN_REQUEST,
    payload
  }
}

export const triggerResetBinData = () => ({
  type: TRIGGER_RESET_BIN_DATA,
});
